import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_4: DocMigration = {
  maxSchemaVersion: "0.0.4",
  apply(json: any) {
    if (!json.planOutputConfig) {
      json.planOutputConfig = {
        staticPlanSheets: [],
        foundationPlanConfig: {
          foundationDetailOverrides: [],
          sideNotes: [],
        },
        interiorDimensionStyle: {
          type: "BY_STRING",
        },
        architecturalPlanSeries: "A",
      };
    }
    if (!json.planOutputConfig.interiorDimensionStyle) {
      json.planOutputConfig.interiorDimensionStyle = {
        type: "BY_ROOM_GROUP",
      };
    }
    return json;
  },
};

export default migration_0_0_4;
